import React from 'react';

import Checkbox from '../cleanMobile/checkbox';
import Comment from '../cleanMobile/comment';

import { useClean } from '../cleanMobile/useClean';

import intro from './asset/back.png';
import terms from './asset/terms.png';

import {
  BGWrap,
  CleanSignUpBtn,
  ClosetStoreBtn,
  CheckGroupBG,
} from './styled';

const CleanMobileComponent = () => {
  const {
    state,
    clickCleanSignUp,
    clickClosetStore,
    clickUserAgreement,
    changeComment,
    submit,
    clickKaKaoShare,
  } = useClean();

  return (
    <>
      <BGWrap width={710} height={4011} imgUrl={intro}>
        <CleanSignUpBtn onClick={clickCleanSignUp} />      

        <ClosetStoreBtn onClick={clickClosetStore} />
      </BGWrap>

      <CheckGroupBG>
        <Checkbox 
          name='checkType1'
          label='(필수) 개인정보 수집 동의'
          isChecked={state.checkType1} 
          checkHander={clickUserAgreement}
        />

        <Checkbox 
          name='checkType2'
          label='(필수) 개인 정보 제3자 제공에 대한 별도 동의'
          isChecked={state.checkType2} 
          checkHander={clickUserAgreement}
        />     
      </CheckGroupBG>

      <Comment 
        state={state} 
        changeComment={changeComment} 
        submit={submit}
        clickKaKaoShare={clickKaKaoShare}
      />
      
      <BGWrap width={710} height={927} imgUrl={terms} />
    </>
  );
};

export default CleanMobileComponent;
